import React, { Component } from "react";
import { positions, Provider as AlertProvider } from "react-alert";
import AlertTemplate from "./helpers/alertTemplate/alert-template";
import { Box } from "@material-ui/core";
// Auth
import AuthEmbeddedProvider from "./providers/AuthEmbeddedProvider";

//Styles
import "@progress/kendo-theme-material/dist/all.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import "./assets/scss/index.scss";
import "./theme/css/reset.css";
import "./theme/css/style-dashboard.css";
import "./theme/css/style-dashboard-v3.css";
import "antd/dist/antd.css";
import "./assets/custom.css";
import "./theme/css/style-telemetry.css";

import HUBContext from "./services/HUBContext";
import { getHardFilter, getTempFilter } from "./common/utils";
import EmbeddedRoutes from "./EmbeddedRoutes";
import { I18nEmbeddedProvider } from "./providers/I18nEmbeddedProvider";

// Alerts options
const alertOptions = {
  timeout: 5000,
  position: positions.MIDDLE,
  containerStyle: { zIndex: 9999 },
};

export class HubContextService {
  locale = localStorage.getItem("locale") || "pt-BR";
  theme = getHardFilter("app-theme") || "blue";
  widgetGroups = [];
  expiredSession = false;
  company = {
    companyID: localStorage.getItem("companyID"),
  };
  setCurrentDashboard = console.log;
  setCompany = (companyID) => {
    this.company.companyID = companyID;
    localStorage.setItem("companyID", companyID || 0);
  };
  setExpiredSession = (expiredSession) => {
    this.expiredSession = expiredSession;
  };
  setWidgetGroups = (widgetGroups) => {
    this.widgetGroups = widgetGroups;
  };
}

export default class AppEmbedded extends Component {
  hubContextProvider = new HubContextService();

  componentDidMount() {
    const widgetGroups = getTempFilter("context-widget-groups");
    if (!!widgetGroups && Array.isArray(widgetGroups))
      this.hubContextProvider.setWidgetGroups(widgetGroups);
  }

  render() {
    return (
      <AuthEmbeddedProvider>
        <I18nEmbeddedProvider>
          <AlertProvider template={AlertTemplate} {...alertOptions}>
            <HUBContext.Provider value={this.hubContextProvider}>
              <Box sx={{ flex: 1 }} className="dash-v3 eden100">
                <EmbeddedRoutes />
              </Box>
            </HUBContext.Provider>
          </AlertProvider>
        </I18nEmbeddedProvider>
      </AuthEmbeddedProvider>
    );
  }
}
